import { render, staticRenderFns } from "./DonutChart53.vue?vue&type=template&id=441aaf96&scoped=true"
import script from "./DonutChart53.vue?vue&type=script&lang=js"
export * from "./DonutChart53.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441aaf96",
  null
  
)

export default component.exports